<div
  #globalNavBar
  class="w-0 min-w-full border-t border-[var(--ion-color-dark)] fixed min-h-20 px-[1rem] shadow-xl select-none gap-x-2 animated flex items-center backdrop-blur-lg bottom-[1rem] left-1/2 -translate-x-1/2 rounded-full border-t-2 border-2 theme-shadow pt-2 pb-2 transition-all overflow-x-auto"
  [style.min-width]="minWidth"
  [ngClass]="{
    'hidden': visible === null,
    'slideOutDownFull pointer-events-none': !visible,
    'slideInUp opacity-100': visible,
    '!opacity-0': transparent,
    '!bg-[var(--ion-color-blue-tint)]': color === 'blue',
    '!bg-[var(--ion-color-green-tint)]': color === 'green',
    '!bg-[var(--ion-color-yellow-tint)]': color === 'yellow',
    '!bg-[var(--ion-color-red-tint)]': color === 'red',
    '!bg-[var(--ion-color-purple-tint)]': color === 'purple',
    '!bg-[var(--ion-color-orange-tint)]': color === 'orange',
    '!bg-[var(--ion-color-pink-tint)]': color === 'pink',
    '!bg-[var(--ion-color-teal-tint)]': color === 'teal',
    '!bg-[var(--ion-color-violet-tint)]': color === 'violet',
    '!bg-[var(--ion-color-gray-tint)]': color === 'gray',
    '!bg-[var(--ion-color-surface-tint)]': color === 'surface',
    '!bg-[var(--ion-color-dark-tint)]': color === 'dark',
    '!bg-[var(--ion-color-light-tint)]': color === 'light',
    '!bg-[var(--ion-color-medium-tint)]': color === 'medium',
    '!bg-[var(--ion-color-white-tint)]': color === 'white',
    '!bg-[var(--ion-color-black-tint)]': color === 'black',
    '!bg-[var(--ion-color-primary-tint)]': color === 'primary',
    '!bg-[var(--ion-color-secondary-tint)]': color === 'secondary',
    '!bg-[var(--ion-color-tertiary-tint)]': color === 'tertiary',
    '!bg-[var(--ion-color-success-tint)]': color === 'success',
    '!bg-[var(--ion-color-warning-tint)]': color === 'warning',
    '!bg-[var(--ion-color-danger-tint)]': color === 'danger',
  }"
>
  <div class="flex-1 flex items-center">
    @if (menuButton.visible) {
    <div
      class="border-[var(--ion-color-dark)] w-0 min-w-[5rem] md:min-w-[5rem] md:[max-width:5rem] flex-1 flex flex-col items-center justify-center cursor-pointer"
      [routerLink]="menuButton.route"
      (click)="
        menuButton.action ? menuButton.action() : menuButtonClicked.emit()
      "
    >
      <app-button
        fill="clear"
        size="small"
        [border]="false"
        [shadow]="false"
        [shape]="'round'"
      >
        <app-icon [name]="menuButton.icon" slot="icon-only"></app-icon>
      </app-button>
      @if (menuButton.label) {
      <div class="text-xs font-semibold">{{ menuButton.label }}</div>
      }
    </div>
    } @for (item of content; track item.icon) {

    <div
      class="animated zoomIn w-0 min-w-[5rem] md:min-w-[5rem] md:[max-width:5rem] flex-1 flex flex-col items-center justify-center cursor-pointer"
      [routerLink]="item.route"
      routerLinkActive="!opacity-100"
      (click)="item.action?.()"
    >
      <app-button
        fill="clear"
        size="small"
        [border]="false"
        [shadow]="false"
        [shape]="'round'"
        [badge]="item.badge"
        [spinner]="item.spinner"
      >
        <app-icon [name]="item.icon"></app-icon>
      </app-button>
      <div class="text-xs font-semibold">{{ item.label }}</div>
    </div>
    }
  </div>
</div>
